var _circle, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPostWriteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 2608827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2608828"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57",
    cx: 31.8979,
    cy: 32.4072,
    r: 31.5,
    fill: "#0074FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_410_5455",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 32,
    height: 33
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 16.1479,
    y: 16.6572,
    width: 31.8215,
    height: 31.8215,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_410_5455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "edit_2",
    d: "M22.7775 41.8493H24.6338L36.0696 30.4134L34.2134 28.5572L22.7775 39.993V41.8493ZM41.7378 28.4909L36.1028 22.9221L37.959 21.0659C38.4673 20.5576 39.0916 20.3035 39.8319 20.3035C40.5721 20.3035 41.1964 20.5576 41.7047 21.0659L43.5609 22.9221C44.0692 23.4304 44.3344 24.0436 44.3565 24.7618C44.3786 25.48 44.1355 26.0932 43.6272 26.6015L41.7378 28.4909ZM39.8153 30.4466L25.7608 44.5011H20.1257V38.866L34.1802 24.8115L39.8153 30.4466Z",
    fill: "white"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostWriteIcon);
export default __webpack_public_path__ + "static/media/PostWriteIcon.c11448cb3eb167927db020053108f118.svg";
export { ForwardRef as ReactComponent };